import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm"; // Importar el modal de confirmación
import ModalAgregarArticuloMenu from './ModalAgregarArticuloMenu'; // Modal para agregar artículo

const ArticulosMenu = ({ restauranteId }) => {
    const [articulosMenu, setArticulosMenu] = useState([]);
    const [busqueda, setBusqueda] = useState(""); // Controla la barra de búsqueda
    const [articuloSeleccionado, setArticuloSeleccionado] = useState(null); // Para almacenar el artículo seleccionado
    const [editandoArticulo, setEditandoArticulo] = useState(null); // Controla la edición de artículos
    const [newImage, setNewImage] = useState(null); // Nueva imagen seleccionada
    const [previewUrl, setPreviewUrl] = useState(null); // Vista previa de la imagen seleccionada
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Para el modal de confirmación
    const [mostrarFormulario, setMostrarFormulario] = useState(false); // Controla la visibilidad del formulario para agregar artículos
    const [showImageModal, setShowImageModal] = useState(false); // Controla la visibilidad del modal de imagen
    const [modalImageUrl, setModalImageUrl] = useState(null); // Almacena la URL de la imagen para mostrar en el modal

    // Función para obtener los artículos del menú asociados a un restaurante
    const obtenerArticulosMenu = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "articulos_menu"
            });                    
            setArticulosMenu(response.data.data[0]); // Guardar los artículos del menú
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerArticulosMenu();  // Llamamos la función para obtener los artículos del menú
    }, []);

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar artículos del menú por búsqueda
    const articulosFiltrados = articulosMenu.filter(
        (articulo) =>
            articulo.restaurante_id === restauranteId && // Filtrar por restaurante
            articulo.nombre.toLowerCase().includes(busqueda) // Filtrar por búsqueda
    );

    // Función para manejar la edición de un artículo
    const editarArticulo = (articulo) => {
        setEditandoArticulo(articulo);
        setPreviewUrl(articulo.fotos ? `/_file/${articulo.fotos.split(",")[0]}` : null); // Mostrar la imagen actual
    };

    // Manejar la selección de una nueva imagen
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setNewImage(file);
        setPreviewUrl(URL.createObjectURL(file)); // Generar vista previa de la nueva imagen
    };

    // Función para guardar los cambios del artículo editado
    const guardarArticuloEditado = async () => {
        try {
            let updatedImageUrl = editandoArticulo.fotos;

            // Si hay una nueva imagen, subirla al servidor
            if (newImage) {
                const formData = new FormData();
                formData.append("file", newImage);
                
                const uploadResponse = await clienteAxios.post("/api/documento/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

                updatedImageUrl = uploadResponse.data.file.filename; // Obtener el nombre de la imagen subida
            }

            // Actualizar el artículo en el servidor
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "articulos_menu",
                id: editandoArticulo.id,
                restaurante_id: editandoArticulo.restaurante_id,
                nombre: editandoArticulo.nombre,
                descripcion: editandoArticulo.descripcion,
                precio: editandoArticulo.precio,
                categoria: editandoArticulo.categoria,
                fotos: updatedImageUrl // Actualizar la URL de la imagen
            });

            setEditandoArticulo(null);
            setNewImage(null);
            obtenerArticulosMenu(); // Actualizar los artículos después de guardar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para abrir el modal de imagen al hacer clic en la miniatura
    const handleImageClick = (imageUrl) => {           
        setModalImageUrl(imageUrl);
        setShowImageModal(true);
    };

    // Función para eliminar un artículo del menú
    const confirmarEliminarArticulo = (articulo) => {
        setArticuloSeleccionado(articulo);
        setShowConfirmModal(true); // Mostrar el modal de confirmación
    };

    const eliminarArticulo = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminar",
                modulo: "articulos_menu",
                id: articuloSeleccionado.id
            });
            setShowConfirmModal(false); // Cerrar el modal de confirmación
            obtenerArticulosMenu(); // Actualizar los artículos después de eliminar
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Artículos del Menú</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar artículo..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para mostrar el formulario de agregar artículo */}
                <button
                    onClick={() => setMostrarFormulario(true)}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                >
                    Agregar Nuevo Artículo
                </button>

                <ul>
                    {articulosFiltrados.map((articulo) => (
                        
                        <li key={articulo.id} className="border p-2 mb-2 mt-4 flex items-center">
                            {/* Mostrar la imagen si existe */}
                            {articulo.fotos && articulo.fotos.trim() !== "" ? (
                                <img
                                    src={`/_file/${articulo.fotos.split(",")[0]}`}
                                    alt="Imagen del artículo"
                                    className="w-24 h-24 object-cover rounded-lg mr-4 cursor-pointer"
                                    onClick={() => handleImageClick(`/_file/${articulo.fotos.split(",")[0]}`)} // Abre el modal con la imagen
                                />
                            ) : (
                                <div className="w-24 h-24 bg-gray-200 flex items-center justify-center rounded-lg mr-4">
                                    {/* Ícono de respaldo si no hay imagen */}
                                    <span className="text-gray-500">Sin imagen</span>
                                </div>
                            )}

                            {editandoArticulo && editandoArticulo.id === articulo.id ? (
                                <div className="flex flex-col">
                                    <h3 className="font-semibold mt-2">Nombre:</h3>
                                    <input
                                        type="text"
                                        value={editandoArticulo.nombre}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, nombre: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={50}
                                    />
                                    <h3 className="font-semibold mt-2">Descripción:</h3>
                                    <input
                                        type="text"
                                        value={editandoArticulo.descripcion}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, descripcion: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={50}
                                    />
                                    <h3 className="font-semibold mt-2">Precio:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.precio}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, precio: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={10}
                                    />
                                    <h3 className="font-semibold mt-2">Categoría:</h3>
                                    <input
                                        type="text"
                                        value={editandoArticulo.categoria}
                                        onChange={(e) =>
                                            setEditandoArticulo({ ...editandoArticulo, categoria: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={50}
                                    />
                                    <h3 className="font-semibold mt-2">Cambiar Imagen:</h3>
                                    <input
                                        type="file"
                                        onChange={handleImageChange}
                                        className="border rounded-lg p-2 mr-2"
                                        accept="image/*"
                                    />
                                    {previewUrl && (
                                        <img
                                            src={previewUrl}
                                            alt="Vista previa"
                                            className="w-24 h-24 object-cover rounded-lg mt-2"
                                        />
                                    )}
                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarArticuloEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoArticulo(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <span><strong>Articulo ID:</strong> {articulo.id}</span><br />
                                    <span><strong>Nombre:</strong> {articulo.nombre}</span><br />
                                    <span><strong>Descripción:</strong> {articulo.descripcion}</span><br />
                                    <span><strong>Precio:</strong> ${articulo.precio}</span><br />
                                    <span><strong>Categoría:</strong> {articulo.categoria}</span><br />
                                    <button
                                        onClick={() => editarArticulo(articulo)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarArticulo(articulo)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal para ver la imagen ampliada */}
            {showImageModal && modalImageUrl && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-70">
                    <div className="relative bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full">
                        <img src={modalImageUrl} alt="Imagen ampliada" className="w-full h-auto object-contain" />
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                            onClick={() => setShowImageModal(false)}
                        >
                            &#10005;
                        </button>
                    </div>
                </div>
            )}

            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este artículo?"
                onConfirm={eliminarArticulo}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar un nuevo artículo */}
            <ModalAgregarArticuloMenu
                show={mostrarFormulario}
                onClose={() => setMostrarFormulario(false)}
                restauranteId={restauranteId}
                onArticuloAgregado={obtenerArticulosMenu} // Actualiza los artículos después de agregar uno nuevo
            />
        </div>
    );
};

export default ArticulosMenu;
